import { render, staticRenderFns } from "./LegacySnapshotRetired.vue?vue&type=template&id=a80a2d24"
import script from "./LegacySnapshotRetired.vue?vue&type=script&lang=js"
export * from "./LegacySnapshotRetired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports